import { render, staticRenderFns } from "./AccountPassword.vue?vue&type=template&id=3e77e290&"
import script from "./AccountPassword.vue?vue&type=script&lang=js&"
export * from "./AccountPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e77e290')) {
      api.createRecord('3e77e290', component.options)
    } else {
      api.reload('3e77e290', component.options)
    }
    module.hot.accept("./AccountPassword.vue?vue&type=template&id=3e77e290&", function () {
      api.rerender('3e77e290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Pages/AccountPassword.vue"
export default component.exports